import { BillingChargeColumnKeySchema } from "@redotech/redo-model/billing/billing-report-columns";
import { AdvancedFilterDataSchema } from "@redotech/redo-model/views/views";
import * as z from "zod/v4";

export const billingViewSchema_ = z.object({
  id: z.string(),
  name: z.string(),
  filters: z.array(AdvancedFilterDataSchema),
  columns: z.array(BillingChargeColumnKeySchema),
  createdAt: z.date(),
  updatedAt: z.date(),
});
export type BillingViewSchema = z.infer<typeof billingViewSchema_>;

export const getBillingViews = {
  name: "getBillingViews" as const,
  input: z.object({}),
  output: z.array(billingViewSchema_),
};

export const createBillingView = {
  name: "createBillingView" as const,
  input: z.object({
    name: z.string(),
    filters: z.array(AdvancedFilterDataSchema),
    columns: z.array(BillingChargeColumnKeySchema),
  }),
  output: billingViewSchema_,
};

export const updateBillingView = {
  name: "updateBillingView" as const,
  input: z.object({
    id: z.string(),
    name: z.string(),
    filters: z.array(AdvancedFilterDataSchema),
    columns: z.array(BillingChargeColumnKeySchema),
  }),
  output: billingViewSchema_,
};

export const deleteBillingView = {
  name: "deleteBillingView" as const,
  input: z.object({ id: z.string() }),
  output: z.object({}),
};
